import { usePipelines } from '../pipelines/usePipelines';

/**
 * Funis que o usuário corrente enxerga.
 *
 * ── Por que isto é hoje um invólucro de uma linha ──
 * Até 08/09/2026 este hook reimplementava, no cliente, uma cascata de 4 níveis lendo
 * `user_pipeline_access` e `team_pipeline_access` (admin/owner passa > regra do usuário >
 * união das regras das equipes > sem regra libera tudo). Essa cascata deixou de ser
 * necessária quando as policies RESTRICTIVE `pipelines_group_scope_select` e
 * `stages_group_scope_select` entraram: o servidor já não devolve o funil proibido, e o
 * `usePipelines()` traz `stages` por **embed**, que também passa pela RLS. Filtrar de novo
 * aqui não estreitava nada — só criava uma SEGUNDA fonte de verdade, livre para divergir da
 * primeira sem ninguém perceber.
 *
 * ── O que foi medido antes de apagar a cascata (produção, 08/09) ──
 * Para os 90 usuários ativos da única org que tem restrição de funil configurada, mais uma
 * amostra de 8 orgs sem restrição, comparei o que a RLS devolve contra o que a cascata
 * calculava. **89 de 90 idênticos**, incluindo as etapas (ex.: audrey.dimani 2 de 8 funis e
 * 16 de 51 etapas pelos dois caminhos).
 *
 * As 3 divergências que apareceram na varredura completa da org são todas na direção
 * "a RLS mostra mais", e todas explicadas:
 *   • bruno.yudi e mariaeduarda.medeiros são **super admins da plataforma** com papel `rep`
 *     nessa org. A RLS dá tudo a super admin (curto-circuito em `viewer_hidden_pipeline_ids`);
 *     a cascata só privilegiava `admin`/`owner` **pelo papel na org**, então os trancava em 2
 *     funis. A RLS está certa — é o que o resto da plataforma já faz com super admin.
 *   • athos.silva NÃO é super admin: ele foi posto à mão (`via=direto`) no grupo
 *     "Financeiro — Diretor de unidade", que tem `pipeline_scope='all'`, enquanto a
 *     `user_pipeline_access` dele ainda bloqueia 6 funis. Os dois eixos discordam e o grupo é
 *     a autoridade por decisão deste projeto — então ele passa de 2 para 8 funis na tela.
 *     ⚠️ Isto já era verdade no banco: a RLS liberava os 8 desde que a policy entrou, e só o
 *     filtro daqui segurava a UI em 2. Ou seja, a restrição dele era cosmética. Para restringir
 *     de verdade, mover para um grupo `selected` ou listar funis no grupo dele.
 *
 * ── Consequência de desenho ──
 * Restringir funil agora é uma coisa só: `access_groups.pipeline_scope` + `access_group_pipelines`.
 * Não existe mais caminho em que a tela mostre um conjunto e o banco permita outro.
 */
export function useVisiblePipelines() {
  return usePipelines();
}
